// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__ylTpd","container":"style_container__HnYzO","frame":"style_frame__MVDbx","content":"style_content__DPFgs"};